import React, {PropTypes} from 'react';
import Link from 'shared/Link.jsx';
import NavigationBarContainer from 'shared/navigationBar/NavigationBarContainer.jsx';
import AuthorizeContainer from 'shared/auth/AuthorizeContainer.jsx';
import UserLoginContainer from './UserLoginContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import {DEFAULT_TOURNAMENT_IMG_LARGE} from 'shared/variables';

const TopBanner = ({
  environment,
  profileIsConfirmed,
  bannerImagePath,
  title,
  subTitle,
  onLogoClick,
  groupName,
  isAllowed
}) => {
  return(
    <div className="top-banner"
      style={{
        background: `linear-gradient(rgba(0, 51, 141, 0.8), rgba(0, 51, 141, 0.8)),
          url(${bannerImagePath || DEFAULT_TOURNAMENT_IMG_LARGE})
          no-repeat center center`,
        backgroundSize: 'cover'
      }}>
      <div className="container">
        <div className="top-banner-logo cursor-pointer"
          onClick={onLogoClick}
        />
        <DisplayIf condition={environment != 'PROD' && environment != 'PRODUCTION'}>
          <div className="top-banner-enironment">
            {environment}
          </div>
        </DisplayIf>

        <DisplayIf condition={isAllowed && groupName != undefined && groupName !== ''}>
          <div className="top-banner-group-name">
            {groupName}
          </div>
        </DisplayIf>

        <div className="top-banner-actions">
          <DisplayIf condition={profileIsConfirmed}>
            <div className="banner-flex-right">
              <Link
                className="btn btn-link"
                to="registration">
                {'Home'}
              </Link>
            </div>
            <AuthorizeContainer admin superuser>
              <DisplayIf condition={isAllowed || groupName == undefined || groupName === ''}>
                <Link className="btn btn-link" to="admin">
                  {'Admin Dashboard'}
                </Link>
              </DisplayIf>
            </AuthorizeContainer>
            <AuthorizeContainer admin manager superuser>
              <DisplayIf condition={isAllowed || groupName == undefined || groupName === ''}>
                <Link className="btn btn-link" to="admin/audit">
                  {'Audit'}
                </Link>
              </DisplayIf>
            </AuthorizeContainer>
            <AuthorizeContainer manager superuser>
              <DisplayIf condition={isAllowed || groupName == undefined || groupName === ''}>
                <Link className="btn btn-link" to="tournament">
                  {'Manage Tournament'}
                </Link>
              </DisplayIf>
            </AuthorizeContainer>
            <AuthorizeContainer financialofficer hqfinancialofficer superuser>
              <DisplayIf condition={groupName && window.GROUP_ENABLED === "true" ? false : false}>
                <Link className="btn btn-link"
                  to="finance">
                  {'Financial Administration'}
                </Link>
              </DisplayIf>
            </AuthorizeContainer>

            <UserLoginContainer />
          </DisplayIf>
          <DisplayIf condition={!profileIsConfirmed}>
            <UserLoginContainer />
          </DisplayIf>
        </div>

        <h1 className="top-banner-title">{title}</h1>
        <h2 className="top-banner-subtitle">{subTitle}</h2>
        <NavigationBarContainer />
      </div>
    </div>
  );
};

TopBanner.defaultProps = {
  environment: 'UNKNOWN'
};

TopBanner.propTypes = {
  environment: PropTypes.string,
  profileIsConfirmed: PropTypes.bool,
  bannerImagePath: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  onLogoClick: PropTypes.func,
  isAllowed: PropTypes.bool
};

export default TopBanner;



// WEBPACK FOOTER //
// ./src/features/shared/topBanner/TopBanner.jsx